import { FC, Fragment, ReactNode } from 'react';
import { Modals } from '@/components/shared/modals/Modals';
import { CookieBanner } from '@/components/shared/cookie-banner/CookieBanner';

interface IFeedLayoutProps {
	children: ReactNode;
}
export const FeedLayout: FC<IFeedLayoutProps> = ({ children }) => {
	return (
		<Fragment>
			<CookieBanner />
			<Modals />
			{children}
		</Fragment>
	);
};
